import { applyMiddleware, createStore, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { persistCombineReducers, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';

import client from './core/services/client';
import graphqlClient from './core/services/graphql';
import rootReducer from './core/reducers';
import { signOut } from './core/actions';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  configureScopeWithState: (scope, state) => {
    const profile = state?.authentication?.profile;
    scope.setUser({
      id: profile ? profile.id : null,
    });
    scope.setTag('scope', state.authentication.scope);
  },
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'authentication',
    'parameters',
    'schedule',
    'templates',
    'treeTest',
    'survey',
    'screenerSessionAnswers',
    'notification',
    'createProject',
  ],
};

const persistedReducer = persistCombineReducers(persistConfig, rootReducer);
const middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

const store = createStore(
  persistedReducer,
  compose(applyMiddleware(...middleware), sentryReduxEnhancer),
);

const persistor = persistStore(store);

store.subscribe(() => {
  const state = store.getState();

  const { authentication: { token, scope } = {} } = state;

  client.setToken(token);
  graphqlClient.setToken(token);
  graphqlClient.setScope(scope);
});

graphqlClient.setUnauthorizedListener(() => {
  store.dispatch(signOut());
});

export { persistor, store };
